var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.24243C4.85775 1.24243 1.5 4.60018 1.5 8.74243C1.5 12.8847 4.85775 16.2424 9 16.2424C13.1422 16.2424 16.5 12.8847 16.5 8.74243C16.5 4.60018 13.1422 1.24243 9 1.24243Z",
    stroke: "#2C358A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62402 9.86646L8.99902 6.49146L12.374 9.86646",
    stroke: "#2C358A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccup);
export default __webpack_public_path__ + "static/media/accup.f3a6516f7b0e2bcf6828bc128cc909c5.svg";
export { ForwardRef as ReactComponent };